'use client';

import { TextField as HeroTextField, TextFieldProps as HeroTextFieldProps } from '@heroui/react';
import { ReactNode } from 'react';

export interface TextFieldProps extends Omit<HeroTextFieldProps, 'className' | 'style'> {
  children: ReactNode;
  width?: 'full' | 'auto';
}

export const TextField = ({ children, width, ...props }: TextFieldProps) => {
  const widthClass = width === 'full' ? 'w-full' : '';
  
  return (
    <HeroTextField
      {...props}
      className={`flex flex-col gap-1 ${widthClass}`}
    >
      {children}
    </HeroTextField>
  );
};
